import { AfterViewInit, Component, EventEmitter, OnChanges, OnDestroy, OnInit, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { arrayMoveMutable } from 'array-move'
import { ApiService } from '../api.service'

declare var $: any

@Component({
	selector: 'app-generate-course-form-pdf',
	templateUrl: './generate-course-form-pdf.component.html',
	styleUrls: ['./generate-course-form-pdf.component.scss']
})

export class GenerateCourseFormPdfComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	userID = 0
	
	courseFormID = 0
	courseFormName = ''
	courseFormHeadingWords = 0
	courseFormCategory = -1
	newCourseID = 0
	
	uploadingPdf = false
	uploadPdfError = false
	pdf: File | undefined = undefined
	existingPdfs: string[] = []
	selectedPdf = ''
	pdfEmbeddedIndex = false
	pdfIndexStart = 0
	pdfIndexEnd = 0
	pdfStructure = false
	units: any[] = []
	pdfExtractTables = false
	pdfTableBorders: '' | 'fino' | 'normal' | 'grueso' = ''

	verifyLoading = false
	verifySuccess = false
	verifyError = false
	verifyMessage = ''
	generateLoading = false
	generateSuccess = false
	generateError = false
	generateMessage = ''

	uploadPdfSub = new Subscription
	getExistingPdfsSub = new Subscription
	verifyTocSub = new Subscription
	taskStatusCelerySub = new Subscription
	generateCoursePdfTocSub = new Subscription
	deleteCourseSub = new Subscription
	importCourseSub = new Subscription

	jsTree: any = $.jstree!

	@Output() moveEvent = new EventEmitter<any>()

	constructor(private dataService: ApiService) { }

	ngOnInit(): void {
		this.userID = this.dataService.getUserID()
		this.getExistingPdfsSub = this.dataService.getUploadedFiles(this.userID, 'pdf')
		.subscribe(
			files => {
				this.existingPdfs = files != null ? files : []
			},
			_error => {
				// console.log(error)
			}
		)
		
		// console.log('form pdf init')
	}
	
	ngAfterViewInit(): void {
		// console.log('form pdf after view init')
	}

	ngOnChanges(): void {
		// console.log('form pdf changes')
	}

	ngOnDestroy(): void {
		this.uploadPdfSub?.unsubscribe()
		this.verifyTocSub?.unsubscribe()
		this.getExistingPdfsSub?.unsubscribe()
		this.taskStatusCelerySub?.unsubscribe()
		this.generateCoursePdfTocSub?.unsubscribe()

		// console.log('form pdf destroy')
	}

	move(event: MouseEvent) {
		this.moveEvent.next(event)
	}

	pdfUpload(event: any) {
		this.uploadingPdf = true
		this.uploadPdfError = false
		let input = event.target as HTMLInputElement
		this.pdf = input.files!.item(0)!
		
		if (this.pdf.type !== "application/pdf") {
			alert("Por favor, suba un archivo PDF válido.")
			input.value = ''
			return
		}
		
		this.uploadPdfSub = this.dataService.uploadFile(this.pdf, 'pdf')
		.subscribe(
			pdfname => {
				pdfname = pdfname.toString()
				if (pdfname.length > 0) {
					this.addPdfToSelect(pdfname)
					input.value = ''
					this.uploadingPdf = false
				}
			},
			_error => {
				// console.log(error)
				this.uploadingPdf = false
				this.uploadPdfError = true
			}
		)
	}

	addPdfToSelect(pdfname: string) {
		let index = this.existingPdfs.findIndex((pdf) => {
			return pdf === pdfname
		})

		if (index > -1) {
			alert("Resubido: " + pdfname)
		} else {
			alert("Subido: " + pdfname)
			this.existingPdfs.push(pdfname)
		}
		this.selectedPdf = pdfname
		this.resetToc()
	}

	openPdf() {
		let url = `${this.dataService.pdfUrl}/${this.userID}/${this.selectedPdf}`
		window.open(url)
	}

	changeSelectedPdf(event: Event) {
		let select = event.target as HTMLSelectElement
		this.selectedPdf = select.value
		this.resetToc()
	}

	resetToc() {
		this.verifyLoading = false
		this.verifyError = false
		this.verifySuccess = false
		this.units = []
		this.pdfExtractTables = false
		this.pdfTableBorders = ''
		this.generateLoading = false
		this.generateError = false
		this.generateSuccess = false
		this.changeEmbeddedIndex()
	}

	changeEmbeddedIndex() {
		if (this.pdfEmbeddedIndex) {
			this.pdfIndexStart = 1
			this.pdfIndexEnd = 1
		} else {
			this.pdfIndexStart = 0
			this.pdfIndexEnd = 0
		}
	}

	verifyToc() {
		this.verifyLoading = true
		this.verifyError = false
		this.verifySuccess = false
		this.units = []
		this.pdfExtractTables = false
		this.pdfTableBorders = ''
		this.generateLoading = false
		this.generateError = false
		this.generateSuccess = false

		this.verifyTocSub = this.dataService.verifyTocPdf(this.userID, this.selectedPdf, this.pdfIndexStart, this.pdfIndexEnd)
		.subscribe(
			data => {
				console.log(data)
				// let status = data.status
				let task = data.id
				// console.log(task)

				let minutes = 0.5
				let interval = 1000 * 60 * minutes
				let idinterval = setInterval(() => {
					this.taskStatusCelerySub = this.dataService.taskStatusCelery('course_pdf', task)
					.subscribe(
						data => {
							// console.log(data)
							
							if (data == null) return 

							let status = data.status
							let status_outline = data.result.status_outline
							this.verifyMessage = data.result.message
	
							if (status === "ERROR") {
								this.verifyLoading = false
								this.verifySuccess = false
								this.verifyError = true
								window.clearTimeout(idinterval)
								this.emptyUnits()

								// console.log(this.units)

								this.jstreeInit()
								return
							}
								
							if (status_outline == null) return
							
							this.verifyLoading = false
							window.clearTimeout(idinterval)

							let units = data.result.units
							
							if (units.length === 0) {
								this.pdfStructure = false
								this.verifyError = true
								this.verifySuccess = false
								this.emptyUnits()
								this.jstreeInit()
								return
							}

							this.pdfStructure = true
							this.verifyError = false
							this.verifySuccess = true

							// console.log(units)
							let units_num = units.length - 1
							for (let u = 0; u <= units_num; u++) {
								let unit = units[u]
								// console.log(unit)
								if (unit === undefined) continue
								// let title = unit.title.toUpperCase()
								// unit.id = unit.idTitle
								delete unit.idTitle
								delete unit.order
								// unit.title = title
								unit.text = unit.title
								unit.type = "unit"
								unit.pos = u
								unit.id = "unit_" + (u + 1)

								let lessons_num = unit.lessons.length - 1
								unit.children = unit.lessons
								for (let l = 0; l <= lessons_num; l++) {
									let lesson = unit.lessons[l]
									if (lesson === undefined) continue
									delete lesson.idTitle
									delete lesson.order
									lesson.text = lesson.title
									lesson.type = "lesson"
									lesson.pos = l
									lesson.unit_pos = u
									lesson.id = unit.id + "_lesson_" + (l + 1)
									// console.log(lesson)
									// console.log(lesson.multimedia)

									let headings_num = lesson.headings.length - 1
									for (let h = 0; h <= headings_num; h++) {
										let heading = lesson.headings[h]
										if (heading === undefined) continue
										delete heading.idTitle
										delete heading.order
										// console.log(heading)
									}
								}
							}
							this.units = units
							// console.log(units)

							// JSTree
							this.jstreeInit()
						},
						_error => {
							// console.log(error)
							window.clearTimeout(idinterval)
						}
					)
				}, interval)
			},
			_error => {
				// console.log(error)
			},
		)
	}

	emptyUnits() {
		this.units.splice(0, this.units.length)
		this.units.push({
			'text': 'Unidad de aprendizaje 1',
			'pos': 0,
			'lessons': [],
			'type': 'unit',
		})
		this.jstreeUpdate()
		// console.log(this.units)
	}

	moveUnit(fromIndex: number, direction: string) {
		let toIndex!: number
		if (direction === 'up') {
			if (fromIndex === 0) return
			toIndex = fromIndex--
		} else if (direction === 'down') {
			if (fromIndex === this.units.length - 1) return
			toIndex = fromIndex++
		}
		let unit = this.units[fromIndex]
		this.units.splice(fromIndex, 1)
		this.units.splice(toIndex, 0, unit)
	}

	generateCoursePdfToc() {
		if (this.pdfExtractTables && this.pdfTableBorders === undefined) {
			alert('Por favor, seleccione el borde que más coincida con las tablas presentes en el documento.')
			return
		}

		this.courseFormID = this.dataService.getCourseFormID()
		this.courseFormName = this.dataService.getCourseFormName()
		// this.courseFormHeadingWords = this.dataService.getCourseFormHeadingWords()
		this.courseFormCategory = this.dataService.getCourseFormCategory()

		this.generateLoading = true
		this.generateSuccess = false
		this.generateError = false

		let pdf = this.selectedPdf
		let outline = JSON.stringify(this.units)
		// console.log(outline)

		if (this.courseFormID > 0) {
			this.deleteCourseSub = this.dataService.deleteCourse(this.courseFormID)
			.subscribe(
				_data => {
					// console.log(data)
				},
				_error => {
					// console.log(error)
				}
			)
		}

		this.generateCoursePdfTocSub = this.dataService.generateCoursePdfToc(this.userID, pdf, outline, this.pdfExtractTables, this.pdfTableBorders!)
		.subscribe(
			data => {
				// console.log(data)
				let task = data.id
				// console.log(task)

				let minutes = 0.5
				let interval = 1000 * 60 * minutes
				let idinterval = setInterval(() => {
					this.taskStatusCelerySub = this.dataService.taskStatusCelery('course_pdf', task)
					.subscribe(
						data => {
							// console.log(data)
							let status = data.status
							
							if (status === "SUCCESS") {
								window.clearTimeout(idinterval)
								
								let result = data.result
								this.generateMessage = result.message
								let units = result.units
								// console.log(units)
								this.importCourseSub = this.dataService.importCourse(units, this.courseFormID, this.courseFormName, this.courseFormHeadingWords, this.courseFormCategory, 'pdf')
								.subscribe(
									id => {
										this.generateLoading = false
										this.generateSuccess = true
										this.generateError = false

										this.dataService.clearCourseForm()
										this.newCourseID = id
									},
									_error => {
										// console.log(error)
										window.clearTimeout(idinterval)
										this.generateLoading = false
										this.generateSuccess = false
										this.generateError = true
										// this.generateMessage = data.message
									}
								)
							}
						},
						_error => {
							// console.log(error)
							window.clearTimeout(idinterval)
							this.generateLoading = false
							this.generateSuccess = false
							this.generateError = true
							this.generateMessage = data.result.message
						},
					)
				}, interval)
			},
			_error => {
				// console.log(error)
				this.generateLoading = false
				this.generateSuccess = false
				this.generateError = true
			}
		)
	}

	// JSTree
	jstreeInit() {
		$(() => {
			var jstree_elem = $("#pdf-jstree")
			var jstree_tree = jstree_elem.jstree(true)
			let icons_root = "assets/img/simpletree-icons/"

			this.jsTree.defaults.contextmenu!.items = (node: any) => {

				let unit_items = {
					newUnit: {
						label: "Insertar unidad",
						icon: icons_root + "folder_add.png",
						action: () => {
							// console.log(node)
							let new_pos = this.units.length + 1
							let node_id = 'unit_' + new_pos
							let new_node_data = {
								'id': node_id,
								'text': 'Unidad ',
								'type': 'unit',
							}
							jstree_tree.create_node("#", new_node_data, "last", (node: any) => {
								jstree_tree.edit("#" + node.id, undefined, (node: any, status: boolean, canceled: boolean) => {
									if (status && !canceled) {
										let title = node.text
										this.units.push({
											'id': node_id,
											'title': title,
											'text': title,
											'lessons': [],
											'type': 'unit',
											'pos': new_pos,
										})
										this.jstreeUpdate()
									}
								})
							})
							
						}
					},
					newLesson: {
						label: "Insertar lección",
						icon: icons_root + "folder_add.png",
						action: () => {
							// console.log(node)
							let unit_pos = +node.original.pos
							let lessons_num = this.units[unit_pos].lessons.length
							let node_id = 'unit_' + (unit_pos + 1) + '_lesson_' + (lessons_num + 1)
							let new_node_data = {
								'id': node_id,
								'text': 'Lección ',
								'type': 'lesson',
							}
							jstree_tree.create_node("#" + node.id, new_node_data, "last", (node: any) => {
								jstree_tree.edit("#" + node.id, undefined, (node: any, status: boolean, canceled: boolean) => {
									// console.log(node)
									if (status && !canceled) {
										this.units[unit_pos].lessons.push({
											'id': node_id,
											'title': node.text,
											'text': node.text,
											'type': 'lesson',
											'headings': [],
											'pos': lessons_num + 1,
											'unit_pos': unit_pos,
										})
										this.jstreeUpdate()
									}
								})
							})
						}
					},
					editUnit: {
						label: "Editar (F2)",
						icon: icons_root + "page_edit.png",
						action: () => {
							// console.log(node)
							jstree_tree.edit("#" + node.id, undefined, (node: any, status: boolean, canceled: boolean) => {
								// console.log(node)
								let unit_pos = +node.original.pos
								this.units[unit_pos].title = node.text
								this.units[unit_pos].text = node.text
								this.jstreeUpdate()
							})
						}
					},
					deleteUnit: {
						label: "Borrar (Supr)",
						icon: icons_root + "page_delete.png",
						action: () => {
							// console.log(node)
							let unit_pos = +node.original.pos
							// console.log(unit_pos)
							if (!confirm("¿Está seguro que quiere borrar esta unidad?")) return
							// jstree.jstree().delete_node("#" + node.id)
							this.units.splice(unit_pos, 1)
							this.jstreeUpdate()
						}
					}
				}

				let lesson_items = {
					editLesson: {
						label: "Editar (F2)",
						icon: icons_root + "page_edit.png",
						action: () => {
							// console.log(node)
							jstree_tree.edit("#" + node.id, undefined, (node: any, status: any, canceled: any) => {
								// console.log
								let lesson_pos = +node.original.pos
								let unit_pos = +node.original.unit_pos
								this.units[unit_pos].lessons[lesson_pos].title = node.text
								this.units[unit_pos].lessons[lesson_pos].text = node.text
								this.jstreeUpdate()
							})
						}
					},
					deleteLesson: {
						label: "Borrar (Supr)",
						icon: icons_root + "page_delete.png",
						action: () => {
							// console.log(node)
							if (!confirm("¿Está seguro que quiere borrar esta lección?")) return
							// jstree.jstree().delete_node("#" + node.id)
							let lesson_pos = +node.original.pos
							let unit_pos = +node.original.unit_pos
							this.units[unit_pos].lessons.splice(lesson_pos, 1)
							this.jstreeUpdate()
						}
					}
				}

				// console.log(node)
				let items = {}
				if (node.type === "unit")
					items = unit_items
				else if (node.type === "lesson")
					items = lesson_items

				return items
			}

			jstree_elem.on("changed.jstree", (e: any, data: any) => {
				// console.log(e)
				// console.log(data)
				/*
				if (data.node !== undefined) {
					let node = data.node
					let type = node.type
					// console.log(type)
					// let id = +data.node.id
					// console.log(id)
				}
				*/
			})

			jstree_elem.on("keydown.jstree", (e: any) => {
				// console.log(e)
				// console.log(e.which)
				if (e.which >= 37 && e.which <= 40) e.preventDefault()
			})

			/*
			jstree_elem.on("select_node.jstree", (node: any, selected: any, event: any) => {
				console.log(node)
				console.log(selected)
				console.log(event)
			})
			*/

			/*
			jstree_elem.on("deselect_all.jstree", (e: any) => {
				// console.log(e)
			})
			*/

			/*
			jstree_elem.on("edit_node.jstree", (e: any, data: any) => {
				console.log(e)
				console.log(data)
			})
			*/

			jstree_elem.on("move_node.jstree", (e: any, data: any) => {
				// console.log(data)
				let node = data.node
				let new_position = data.position
				let old_position = data.old_position
				// console.log("old_position: " + old_position)
				let type = node.type
				let new_parent = jstree_tree.get_node(data.parent)
				// console.log(new_parent)
				let new_parent_type = new_parent.type
				let old_parent = jstree_tree.get_node(data.old_parent)
				// console.log(old_parent)
				if (type === 'unit') {
					if (new_parent_type === '#') {
						arrayMoveMutable(this.units, old_position, new_position)
					}
					else if (new_parent_type === 'unit') {
						let unit_pos = +new_parent.original.pos - 1
						// let unit_pos = +new_parent.id.replace('unit_', '') - 1
						if (unit_pos < 0) unit_pos = 0
						else if (unit_pos > this.units.length) unit_pos = this.units.length - 1
						// console.log("unit_pos: " + unit_pos)
						let lessons_num = this.units[unit_pos].lessons.length
						let lesson_id = 'unit_' + (old_position + 1) + '_lesson_' + (lessons_num + 1)
						this.units.splice(old_position, 1)
						this.units[unit_pos].lessons.push({
							'id': lesson_id,
							'title': node.text,
							'text': node.text,
							'type': 'lesson',
							'headings': [],
							'pos': lessons_num + 1,
							'unit_pos': unit_pos,
						})
					}
				} else if (type === 'lesson') {
					let unit_pos = +node.original.unit_pos
					arrayMoveMutable(this.units[unit_pos].lessons, old_position, new_position)
				}
				this.jstreeUpdate()
			})

			// jstree_elem.on("dnd_start.vakata", (data: any, elem: any, helper: any, e: any) => {
			jstree_elem.on("dnd_start.vakata", (e: any, data: any) => {
				// console.log(data)
				// console.log('start')
				// this.jstreeUpdate()
			})

			jstree_elem.on("dnd_move.vakata", (data: any, elem: any, helper: any, e: any) => {
				// console.log(data)
				// console.log('moving')
				// this.jstreeUpdate()
			})

			// jstree_elem.on("dnd_stop.vakata", (data: any, elem: any, helper: any, e: any) => {
			jstree_elem.on("dnd_stop.vakata", (e: any, data: any) => {
				// console.log(data)
				// console.log('stop')
				// this.jstreeUpdate()
			})

			jstree_elem.on("before_open.jstree", (e: any, data: any) => {
				document.querySelector('#' + data.node.id + '_anchor > svg')?.setAttribute('data-icon', 'folder-open')
			})

			jstree_elem.on("after_close.jstree", (e: any, data: any) => {
				document.querySelector('#' + data.node.id + '_anchor > svg')?.setAttribute('data-icon', 'folder')
			})

			jstree_elem.jstree({
				"core": {
					"check_callback": true,
					"themes": {
						"name": "default",
					},
					"data": this.units,
					/* 
					(operation, node, node_parent, node_position, more) => {
						// operation can be "create_node", "rename_node", "delete_node", "move_node", "copy_node" or "edit"
						// in case of "rename_node" node_position is filled with the new node name
						return operation === "rename_node" ? true : false
					}, 
					*/
					"keyboard": {
						'up': (e: any) => {
							// console.log(e)
							// console.log(e.originalEvent)
							let shift = e.originalEvent.shiftKey
							// console.log(shift)
							let node = jstree_tree.get_selected()[0]
							// console.log(node)
							let prev_node = jstree_tree.get_prev_dom(node)[0].id
							// console.log(prev_node)
							if (!shift) jstree_tree.deselect_all(true)
							jstree_tree.select_node(prev_node, false, false, e)
						},
						'down': (e: any) => {
							// console.log(e)
							// console.log(e.originalEvent)
							let shift = e.originalEvent.shiftKey
							// console.log(shift)
							let node = jstree_tree.get_selected()[0]
							// console.log(node)
							let next_node = jstree_tree.get_next_dom(node)[0].id
							// console.log(next_node)
							if (!shift) jstree_tree.deselect_all(true)
							jstree_tree.select_node(next_node, false, false, e)
						},
						/*
						'left': () => {
							alert("ArrowLeft")
						},
						*/
						/*
						'right': () => {
							alert("ArrowRight")
						},
						*/
						'delete': () => {
							// alert("Borrar")
							let nodes = jstree_tree.get_selected(true).reverse()
							let confirm_msg = ""
							if (nodes.length === 1) confirm_msg = "¿Está seguro que quiere borrar este elemento?"
							else if (nodes.length > 1) confirm_msg = "¿Está seguro que quiere borrar estos elementos?"
							if (!confirm(confirm_msg)) return
							nodes.forEach((node: any) => {
								// console.log(node)
								let type = node.type
								if (type === 'unit') {
									let id = +node.id.replace('unit_', '') - 1
									// console.log(id)
									this.units.splice(id, 1)
								}
							})
							this.jstreeUpdate()
						},
					}
				},
				"contextmenu": {
					"show_at_node": false
				},
				"dnd": {
					"copy": false,
					"is_draggable": true,
					"check_while_dragging": true,
				},
				"types": {
					"#": {
						"max_depth": 2,
						"valid_children": ["unit"],
					},
					"unit": {
						"icon": "fas fa-folder me-2",
						"max_depth": 1,
						"valid_children": ["lesson"],
					},
					"lesson": {
						"icon": "fas fa-folder me-2",
					},
				},
				"plugins": ["changed", "contextmenu", "dnd", "types", "wholerow"]
			})

			jstree_tree = jstree_elem.jstree(true)
		})
	}

	jstreeUpdate() {
		$(() => {
			let jstree = $("#pdf-jstree").jstree(true)
			
			let units_num = this.units.length - 1
			for (let u = 0; u <= units_num; u++) {
				let unit = this.units[u]
				unit.pos = u
				unit.id = 'unit_' + (u + 1)
				unit.children = unit.lessons

				let lessons_num = unit.lessons.length
				for (let l = 0; l <= lessons_num; l++) {
					let lesson = unit.lessons[l]
					if (lesson === undefined) continue
					lesson.pos = l
					lesson.unit_pos = u
					lesson.id = unit.id + '_lesson_' + (l + 1)
				}
			}

			jstree.settings!.core.data = this.units
			jstree.deselect_all()
			jstree.refresh(true)
		})
		// console.log(this.units)
	}

	importUnits(event: Event) {
		let input = event.target as HTMLInputElement
		let file = input.files!.item(0)!
		// console.log(file)
		// let json = JSON.parse(input.files!.item(0)!)
		let reader = new FileReader()
		reader.onload = () => {
			let result = reader.result!.toString()
			// console.log(result)
			this.units = JSON.parse(result)
			this.jstreeUpdate()
		}
		reader.readAsText(file)
	}
	
	exportUnits() {
		let unitsJson = JSON.stringify(this.units)
		let element = document.createElement('a')
		element.setAttribute('href', 'data:text/jsoncharset=UTF-8,' + encodeURIComponent(unitsJson))
		element.setAttribute('download', this.selectedPdf.replace('.pdf', '') + '.json')
		element.style.display = 'none'
		document.body.appendChild(element)
		element.click()
		document.body.removeChild(element)
	}

}
